<template>
    <div class="add-mentee-form">   
      <div class="add-form-wrapper">
        <h3 class="add-form-heading">Edit Mentee</h3>
      </div>

      <div class="content-main-wrapper center">
        <div class="row" v-show="successMessage != ''">
          <div class="col-12 p-0">
            <div class="alert alert-success" role="alert">
              {{ successMessage }}
            </div>
          </div>
        </div>

        <form ref="anyName" @submit.prevent="onSubmit">
		      <div class="row">
		        
              <div class="col-12 p-0">
      			  <input
      					type="first_name"
      					name="first_name"
      					id="first_name"
      					class="col-12 col-sm-12 input-height-35 form-control"
      					ref="first_name"
      					v-validate="{ rules: { required: true, regex: nameRegex() } }"
      					v-model="firstName"
                data-vv-as="First name"
                placeholder="First Name"
                maxlength="180">
      			  <div v-if="verrors.firstByRule('first_name', 'required')" class="validate-warning-msg">The First Name is required</div>
              <div v-if="verrors.firstByRule('first_name', 'regex')" class="validate-warning-msg">The First Name should only contain - and _</div>
            </div>
         
             <div class="col-12 p-0" style="margin-top: 10px;">     
              <input
                type="last_name"
                name="last_name"
                id="last_name"
                class="col-12 col-sm-12 input-height-35 form-control"
                ref="last_name"
                v-validate="{ rules: { required: true, regex: nameRegex() } }"
                v-model="lastName"
                data-vv-as="Last name"
                placeholder="Last Name"
                maxlength="180">
              <div v-if="verrors.firstByRule('last_name', 'required')" class="validate-warning-msg">The Last Name is required</div>
              <div v-if="verrors.firstByRule('last_name', 'regex')" class="validate-warning-msg">The Last Name should only contain - and _</div>
            </div>
         
            <div class="col-12 p-0" style="margin-top: 10px;">
              <label
              for="email"
              class="font-weight-bold d-block mb-0">Email Address:</label>
                    {{ email }}            
            </div>

            <div class="col-12 p-0" style="margin-top: 10px;">         
              <input
                  type="phone_number"
                  name="edit_phone_number"
                  id="phone_number"
                  class="col-12 col-sm-12 input-height-35 form-control"
                  ref="phone_number"
                  @keyup="adminPhoneValid($event)"
                  @blur="adminPhoneValid($event)"
                  v-validate="{ rules: { regex: adminPhoneRegex() } }"
                  v-model="phoneNo"
                  data-vv-as="Phone number"
                  placeholder="Phone Number"
                  maxlength="14">
             <div v-if="verrors.has('phone_number')" class="validate-warning-msg">The Phone Number is invalid</div>
            </div>
        

            <div class="col-12 p-0" style="margin-top: 10px;" v-if="pickerLoading == true">
                <label
                    for="hire_date"
                    class="col-12 bold">Hire Date:</label>
                <div class="month-picker-elm-container">
                  <month-picker-input 
                    :default-month="hire_date_month"
                    :default-year="hire_date_year"
                    :clearable="clearable"
                    :editable-year="false"
                    :date-format="month_picker_date_format"
                    input-class="col-12 col-sm-12 input-height-35 form-control"
                    :input-pre-filled="input_pre_filled"
                    @input="input_hire_date"
                    @clear="clearMonthPicker"
                    :max-date="input_max_date" 
                    :no-default="true"
                    >
                  </month-picker-input>
                  <i class="fa fa-calendar red-color" aria-hidden="true"></i>
                  <div v-show="verrors.has('hire_date')" class="validate-warning-msg">{{ verrors.first('hire_date') }}</div>
                </div>
            </div>
       
            <div class="col-12 p-0" style="margin-top: 7px;">
              <label
                  for="mentor"
                  class="col-12 bold"> Assign Mentors: <span class="required">*</span></label>
                  <div class="col-12 col-sm-12 tasklist-assign-wrapper"  v-for="(option, key, index) in editGroups">
                    <div class="chkboxwrapper">
                      <div class="custom-control custom-checkbox">
                        <input 
                        name="mentor_assigned"
                        :value="option.id" 
                        :id="'edit_mentee_mentor_' + option.id" 
                        type="checkbox" 
                        v-model="mentor_assigned"
                        v-validate="'required'"
                        class="custom-control-input"
                        > 
                        <label class="custom-control-label" :for="'edit_mentee_mentor_' + option.id">{{ option.groupName }}</label> 
                      </div>
                    </div>
                  </div>
                  <div v-if="verrors.has('mentor_assigned')" class="margin-bottom-5 validate-warning-msg">Mentor is required</div>

            </div> 

           
           <div class="col-12 p-0"  v-if="editPathwayList.length > 0" style="margin-top: 10px;">
                <label
                    for="roles"
                    class="col-12 bold">Assign Pathway: </label>
                <div class="col-12 col-sm-12 tasklist-assign-wrapper" v-for="(pathway, key, index) in editPathwayList">
                  <div class="chkboxwrapper">
                    <div class="custom-control custom-radio">
                      <input 
                        name="pathway_assigned"
                        :value="pathway.id"                       
                        type="radio" 
                        v-model="editpathwaySelected"
                        @change="getPathwaySteps"
                        v-validate="'required'"
                        class="custom-control-input"
                        :id="'edit_mentee_pathway_' + pathway.id"
                        >
                      <label class="custom-control-label" :for="'edit_mentee_pathway_' + pathway.id">{{ pathway.pathwayName }}</label>
                    </div>
                  </div>
                </div>
                <div v-if="verrors.has('pathway_assigned')" class="margin-bottom-5 validate-warning-msg">Pathway is required</div>
           </div>


           <div class="col-12 p-0"  v-if="editPathwayList.length > 0" style="margin-top: 10px;">
               <div class="row">
                <div class="col-8 d-inline"> 
                  <label
                      for="roles"
                      class="col-12 bold">Begin at step: </label>
                </div>     
                <div class="col-4">
                  <div class="chkboxwrapper">
                    <div class="custom-control custom-checkbox">
                      <input 
                        name="future steps"
                        value="1"                                           
                        type="checkbox" 
                        v-model="editShowFutureSteps"                      
                        class="custom-control-input"
                        :id="'edit_mentee_future_steps'" 
                        >
                      <label class="custom-control-label" :for="'edit_mentee_future_steps'">Show future steps</label>
                    </div>
                  </div>
                </div>
               </div> 
                <div class="col-12 col-sm-12 tasklist-assign-wrapper" v-for="(step, key, index) in pathwaySteps">
                  <div class="chkboxwrapper">
                    <div class="custom-control custom-radio">
                      <input 
                        name="Begin at step"
                        :value="step.id"                       
                        type="radio" 
                        v-model="editStepSelected"                      
                        class="custom-control-input"
                        :id="'edit_mentee_step_' + step.id"
                        >
                      <label class="custom-control-label" :for="'edit_mentee_step_' + step.id">{{ step.stepTitle }}</label>
                    </div>
                  </div>
                </div>
           </div>

      </div>

    <div class="submit margin-bottom-15" style="text-align: center;">
        <button :disabled="disable_edit_mentee" type="submit" class="btn btn-info ma-blue-btn">Save</button>
        <div class="mt-2 mb-5" v-if="((roles.indexOf('ROLE_MENTOR') === -1) && (status == 'Active'))">
          <div class="btn btn-link save_add_link branding_text_color bold" @click="openPromoteMentorModal()">Promote to Mentor</div>
        </div>
    </div>
   </form>
  </div>

        <PromoteMentor
          :isModalVisible="isPromoteMentorModalVisible"
          ref="PromoteMentorModal"
          @close="isPromoteMentorModalVisible = false">
        </PromoteMentor>

</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import moment from 'moment';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import VeeValidate from 'vee-validate';
import axios from 'axios';
import router from '../../router/index.js';
import { store } from '../../store/store';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { MonthPickerInput } from 'vue-month-picker';
import { handleMonthPickerYearNavButtons } from '@/components/shared/utils.js';
import PromoteMentor from '@/components/manager/promote_mentor.vue'


import Multiselect from 'vue-multiselect';

const today = new Date();
today.setHours(0, 0, 0, 0);

const todayMoment = moment();

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});
Vue.use(MonthPickerInput);

export default {
  data: function () {
    return {
      firstName: '',
      lastName: '',
      phoneNo: '',
      email: '',
      edit_mentor: '',
      password: '',
      pw_confirm: '',
      editGroups: [],
      editPathwayList: [],
      pathwaySteps: [],
      editPathwaySelected: '',
      stepSelected: '',
      editShowFutureSteps: 0,
      defaultstep: '',
      accountId: '',
      hire_date: '',
      mentor_assigned: [],
      editMentorSelected: [],
      assessments: [],
      assessmentSelected: [],
      courses: [],
      courseSelected: [],
      accountItems: [],
      usertype_options: [],
      isFormAccess: false,
      user_type: '',
      month_picker_date_format: '%n, %Y',
      hire_date_month: null,
      hire_date_year: null,
      input_max_date: todayMoment.toDate(),
      input_pre_filled: false,
      hire_date_selected: false,
      assignLicense: 0,
      menteeId: '',
      editStepSelected: '',
      existingPathway: '',
      successMessage: '',
      disable_edit_mentee: false,
      clearable: false,
      pickerLoading: false,
      isPromoteMentorModalVisible: false,
      roles: [],
      status: '',
    };
  },
 methods: {
  openPromoteMentorModal() {
    this.$refs.PromoteMentorModal.initial(this.menteeId);
    this.isPromoteMentorModalVisible = true;
  },
  nameRegex: function() {
    return /^[a-zA-Z-_ ']*$/;
  },
  adminPhoneRegex: function() {
    return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  },
  getPathwaySteps() {
    axios('/get-pathway-steps-name',
        {
          method: 'GET',
          params: {
            pathway_id: this.editpathwaySelected,
          }
        },
      )
      .then(response => {
            this.defaultstep = response.data[0].id;            
            this.pathwaySteps = response.data;
       })
      .catch(error => {

      });
  },
  getMenteeData(menteeId) {
    this.pickerLoading = false;
   this.menteeId =  menteeId;
      this.month_picker_date_format = '%n, %Y';
      this.hire_date_month = null;
      this.hire_date_year = null;
      this.input_max_date = todayMoment.toDate();
      this.input_pre_filled = true;
      this.hire_date_selected = false;
   
   axios('/desktop/v2/mentee-details/' + menteeId + '/' + this.$store.state.user_accountid,
        {
          method: 'GET',         
        },
      )
      .then(response => {
          this.firstName = response.data.mentee_first_name;
          this.lastName = response.data.mentee_last_name;
          this.email = response.data.mentee_email;
          this.phoneNo = response.data.mentee_phone_no;
          this.editpathwaySelected = response.data.mentee_pathway;
          this.editShowFutureSteps = response.data.show_future_steps;
          this.editStepSelected = response.data.begin_step;
          this.mentor_assigned = response.data.mentors_list;
          this.existingPathway =  response.data.mentee_pathway;
          this.roles = response.data.roles;
          this.hire_date = response.data.hire_date;
          this.status = response.data.status;
          if (this.hire_date) {
            const hireDate = moment(this.hire_date);
            this.hire_date_month = hireDate.month() + 1;
            this.hire_date_year = hireDate.year();
            this.input_pre_filled = true;
            this.hire_date_selected = true;
          }
          else {
            this.hire_date_month = null;
            this.hire_date_year = null;
            this.input_pre_filled = true;
            this.hire_date_selected = false;
          }
          setTimeout(() => {
            this.pickerLoading = true;
          }, 500);
          for(var i=0; i<this.editPathwayList.length; i++) {
              if(this.editpathwaySelected == this.editPathwayList[i].id) {
                  this.getPathwaySteps();
              }
              
          }
       })
      .catch(error => {

      });   

    axios('/accountgroupsactive',
        {
          method: 'GET',
          params: {
            account_id: this.$store.state.user_accountid,
            current_mentor_id: this.menteeId,
          }
        },
      )
      .then(response => {
          this.editGroups = response.data;        
       })
      .catch(error => {

      });

     
    axios('/get-pathway-add-mentee',
          {
            method: 'GET',
            params: {
              account_id: this.$store.state.user_accountid,
            }
          },
        )
        .then(response => {
              this.editPathwayList = response.data;
         })
        .catch(error => {

        });


  },
  doUpdateMentee() {      
            this.$validator.validateAll().then((result) => {
              this.disable_edit_mentee = true;
                if(!result) {
                    return;
                }
                axios('/desktop/v2/mentee-update',
                {
                    method: 'POST',
                    data: {
                    "mentee_id" : this.menteeId,
                    "first_name": this.firstName,
                    "last_name": this.lastName,
                    "phone_number": this.phoneNo,
                    "pathway_assigned": this.editpathwaySelected,
                    "show_future_steps": this.editShowFutureSteps,
                    "begin_step": this.editStepSelected,
                    "mentor_assigned": this.mentor_assigned,
                    "account_id": this.$store.state.user_accountid,
                    "hire_date": this.hire_date,
                    "existing_pathway": this.existingPathway,
                    }
                },
                )
                .then((response)=> {     
                  this.disable_edit_mentee = false;              
                    // this.flash({ message: 'Profile updated successfully', variant: 'success' });
                    this.successMessage = 'Mentee Edited Successfully!';
                    this.$refs.first_name.focus();

                    setTimeout(() => {
                      this.successMessage = '';
                      this.$parent.hide();
                      this.$router.push(this.$router.currentRoute.path)
                      this.$router.go();
                    }, 2000);
                })
                .catch(() => {
                  this.disable_edit_mentee = false;
                });
            }).catch(() => {
                // catches the error;
            });
  }, 
  adminPhoneValid: function(event) {
    var phone_val = this.phone_number;
    this.phone_number = phone_val.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  },
	onSubmit () {
      this.$validator.validateAll().then((result) => {
        if(!result) {
          return;
        }
        this.doUpdateMentee();
      })
      .catch(() => {

      });
	},  
  navigate(path) {
    router.push(path);
  },
    notBeforeToday(date) {
      return date < today;
    },
    getMentorDisplayText(count, name) {
      if (count == 1) {
          return name[0].text;
      } else {
          var num = (count - 1);
          if (count > 2) {
              var otherText = num + " Others";
          } else {
              var otherText = num + " Other";
          }
          return name[0].text + ", +" + otherText;
      }
    },
    getUserTypeOptions() {
      if (this.$route.name == "addapprentice") {
        this.usertype_options = [
          {value: '', text: 'Select User Type'},
          {value: 'apprentice', text: 'Apprentice'},
        ] 
      } else {
        this.usertype_options = [
          {value: '', text: 'Select User Type'},
          {value: 'mentee', text: 'Mentee'}
        ] 
      }
    },
    clearMonthPicker() {
      this.$emit('clear');
    },
    input_hire_date(data) {
      this.hire_date = data.year + '-' + (data.monthIndex < 10 ? '0' + data.monthIndex : data.monthIndex) + '-01';
    },
  },
  components: {
    UserMenu,
    GoBack,
    DatePicker,
    Multiselect,
    MonthPickerInput,
    PromoteMentor,
  },
  created: function() {
   
  },
  mounted() {
    handleMonthPickerYearNavButtons();
  },
}
</script>

<style scoped>
.start-button-blue {
    color: #fff;
    background-color: #29A3E4;
    border: 1px solid #29A3E4;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 900;
    padding: 10px 10px 10px 10px;
    line-height: 8px;
    width: 130px; 
}
.tasklist-assign-wrapper label {
  font-weight: normal;
}
.tasklist-assign-wrapper .chkboxwrapper {
  margin-bottom: 5px;
}
.mx-datepicker {
  width: 100%;
}
.signin-form input {
  border: 1px solid #ced4da;
}
.content-main-wrapper {
  width: 90% !important;
  background-color: #FFF !important;
  padding: 25px;
}
input {
  line-height: 17px;
  border-radius: 10px;
  padding-left: 5px !important;
  border: 1px solid #707070;
}
.add-form-heading {
  font-size: 18px;
  font-weight: bold;    
}
.add-form-wrapper {
  margin: 0px 10px 0px 30px; 
}
.add-mentee-form label.bold{
  font-weight: 600;
  padding-left: 0px;
}
/deep/ .month-picker-input-container {
  width: 100% !important;
}
/deep/ .month-picker-input {
  width: 100%;
}
/deep/ .month-picker__container {
  z-index: 9999;
  width: 100% !important;
}
.month-picker-elm-container {
  position: relative;
}
.month-picker-elm-container .fa-calendar {
  position: absolute;
  top: 35%;
  right: 5%;
  pointer-events: none;
  color: #00ACEE;
}    
</style>



// WEBPACK FOOTER //
// src/components/manager/edit_mentee.vue